import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isSupportedLang } from '../../constants/languages';

const DISMISS_KEY = 'geLangBannerDismissed';
const ACCEPTED_KEY = 'geLangBannerAccepted';

function isInGeorgia() {
    try {
        return (
            Intl.DateTimeFormat().resolvedOptions().timeZone === 'Asia/Tbilisi'
        );
    } catch {
        return false;
    }
}

function isDismissed() {
    try {
        const raw = localStorage.getItem(DISMISS_KEY);
        if (!raw) return false;
        const ts = parseInt(raw, 10);
        if (!Number.isFinite(ts)) return false;
        return Date.now() - ts < 30 * 24 * 3600 * 1000;
    } catch {
        return false;
    }
}

function dismiss() {
    try {
        localStorage.setItem(DISMISS_KEY, String(Date.now()));
    } catch {}
}

function wasAccepted() {
    try {
        return sessionStorage.getItem(ACCEPTED_KEY) === '1';
    } catch {
        return false;
    }
}

function markAccepted() {
    try {
        sessionStorage.setItem(ACCEPTED_KEY, '1');
    } catch {}
}

export default function GeLangBanner() {
    const { i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        if (i18n.language === 'ge') {
            setIsVisible(false);
            return undefined;
        }
        if (wasAccepted()) {
            dismiss();
            setIsVisible(false);
            return undefined;
        }
        if (!isInGeorgia()) return undefined;
        if (isDismissed()) return undefined;

        const t = setTimeout(() => setIsVisible(true), 800);
        return () => clearTimeout(t);
    }, [i18n.language, location.pathname]);

    if (!isVisible) return null;

    const handleSwitch = () => {
        const segments = location.pathname.split('/').filter(Boolean);
        const rest = isSupportedLang(segments[0])
            ? segments.slice(1)
            : segments;
        const newPath = rest.length ? `/ge/${rest.join('/')}` : '/ge/';
        markAccepted();
        i18n.changeLanguage('ge');
        navigate(newPath + location.search + location.hash, { replace: true });
        setIsVisible(false);
    };

    const handleDismiss = () => {
        dismiss();
        setIsVisible(false);
    };

    return (
        <div
            className="cookie-banner cookie-banner--visible"
            style={{
                position: 'fixed',
                bottom: 0,
                left: 0,
                right: 0,
                zIndex: 9998,
            }}
        >
            <div className="cookie-banner__container">
                <div className="cookie-banner__content">
                    <div className="cookie-banner__icon">🇬🇪</div>
                    <div className="cookie-banner__text">
                        <div className="cookie-banner__description">
                            გამარჯობა! თუ საქართველოდან ხართ — სცადეთ ქართული
                            ვერსია.
                        </div>
                    </div>
                </div>

                <div className="cookie-banner__actions">
                    <button
                        type="button"
                        className="cookie-banner__button cookie-banner__button--decline"
                        onClick={handleDismiss}
                    >
                        ×
                    </button>
                    <button
                        type="button"
                        className="cookie-banner__button cookie-banner__button--accept"
                        onClick={handleSwitch}
                    >
                        ქართული
                    </button>
                </div>
            </div>
        </div>
    );
}
